import { ReactNode } from "react";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { AdminSidebar } from "./AdminSidebar";
import BohoNav from "@/components/BohoNav";
import BohoFooter from "@/components/BohoFooter";
import { LiveClock } from "./LiveClock";

interface AdminLayoutProps {
  children: ReactNode;
  title?: string;
  description?: string;
  showDashboardHeader?: boolean;
}

export function AdminLayout({ children, title, description, showDashboardHeader = false }: AdminLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      <BohoNav />
      
      <SidebarProvider>
        <div className="flex min-h-[calc(100vh-64px)] w-full">
          <AdminSidebar />
          
          <main className="flex-1 flex flex-col">
            {/* Admin Header */}
            <header className="sticky top-0 z-40 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
              <div className="flex h-14 items-center gap-4 px-4">
                <SidebarTrigger className="h-8 w-8 p-0" />
                
                <div className="flex-1 flex items-center justify-between">
                  {/* Dashboard Header Info */}
                  {showDashboardHeader ? (
                    <div className="flex-1 flex items-center justify-between">
                      <div className="flex flex-col">
                        <h1 className="text-xl font-bold tracking-tight">Admin Dashboard</h1>
                        <p className="text-xs text-muted-foreground">Live system status and admin metrics</p>
                      </div>
                      <div className="flex items-center">
                        <LiveClock compact={true} />
                      </div>
                    </div>
                  ) : (
                    title && (
                      <div>
                        <h1 className="text-lg font-semibold">{title}</h1>
                        {description && (
                          <p className="text-sm text-muted-foreground">{description}</p>
                        )}
                      </div>
                    )
                  )}
                </div>
              </div>
            </header>

            {/* Main Content */}
            <div className="flex-1 p-6">
              {children}
            </div>
          </main>
        </div>
      </SidebarProvider>
      
      <BohoFooter />
    </div>
  );
}